import React from 'react';
import PropTypes from 'prop-types';
import SMConst from 'lib/SMConst';
import SMOwnerResource from 'resources/SMOwnerResource';
import SMRoomHelper from 'components/helpers/SMRoomHelper';
import SMFormatHelper from 'components/helpers/SMFormatHelper';
import SMA8Beacon from 'components/others/SMA8Beacon';
import SMTrackHelper from 'components/helpers/SMTrackHelper';

class SMOSettingEditReviewFragmentView extends React.Component {
  
  constructor(props) {
    super(props);
    this.state = {
      owner: this.props.owner, 
      reviewRequiredRooms: [],
      hasDisplayableRoom: false,
      room: null,
      display: SMConst.Display.Init,
      isCurrent : this.props.isCurrent,
      requestStatus: null
    };
  }
  
  componentDidMount() {
    window.addEventListener('resize', this.sizeToFit.bind(this), false);
    if (this.state.isCurrent) this.sizeToFit();
    
    $(this.refs.fragment).startLoading();
    SMOwnerResource.getRooms(this.state.owner.id, { per_page: 1000 }, (rooms, error)=>{
      let reviewRequiredRooms = [];
      let hasDisplayableRoom = false;
      if(!error) {
        rooms.forEach((room)=>{
          if (room.can_display && room.space.can_display) {
            hasDisplayableRoom = true;
            if (SMRoomHelper.isAllowedRentType(room, SMConst.RentType.Stay) && 
                SMRoomHelper.isRequiredReview(room)) {
              reviewRequiredRooms.push(room);
            }
          }
        });
        this.setState({
          hasDisplayableRoom: hasDisplayableRoom,
          display: SMConst.Display.Visible,
          reviewRequiredRooms: reviewRequiredRooms,
        });
        $(this.refs.fragment).stopLoading();
      }
    });
  }
  
  componentWillUnmount() {
    window.removeEventListener('resize', this.sizeToFit.bind(this), false);
  }
  
  componentWillReceiveProps(nextProps) {
    this.setState({
      isCurrent : nextProps.isCurrent,
      owner : nextProps.owner,
    });
  }
  
  componentDidUpdate() {
    if (this.state.isCurrent) this.sizeToFit();
  }
  
  sizeToFit() {
    let $mainTable = $("#js-split_view-main"),
        $mainTableFooter = $(this.refs.mainTableFooter);
        
    // main
    $mainTableFooter.outerWidth($mainTable.outerWidth());
  }

  hasValidOwnerInfo() {
    let owner = this.state.owner;
    return (owner.personal_certificate.name &&
            owner.gender &&
            this.hasAddress() &&
            this.hasName() &&
            owner.birth_date &&
            (!owner.is_corp || (owner.corp_name_en && owner.business_tax_id && this.hasPersonalAddress())));
  }
  
  hasAddress() {
    let owner = this.state.owner;
    return (owner.postal_code && owner.state && 
            owner.city && owner.address_1 && owner.address_2 &&
            owner.city_kana && owner.address_1_kana && owner.address_2_kana);
  }
  
  hasName() {
    let owner = this.state.owner;
    return (owner.family_name && owner.family_name_kana &&
            owner.given_name && owner.given_name_kana);
  }
  
  hasPersonalAddress() {
    let owner = this.state.owner;
    return (owner.personal_postal_code && owner.personal_state && 
            owner.personal_city && owner.personal_address_1 && owner.personal_address_2 &&
            owner.personal_city_kana && owner.personal_address_1_kana && owner.personal_address_2_kana);
  }
  
  hasBankAccount() {
    return this.state.owner.has_bank_account;
  }

  hasDisplayableRoom() {
    return this.state.hasDisplayableRoom;
  }

  canRequestOwnerCertificate() {
    return this.hasValidOwnerInfo() && this.hasDisplayableRoom() && this.hasBankAccount();
    // return this.hasValidOwnerInfo() && this.hasDisplayableRoom();
  }

  fragmentStyle(){
    return {
      display: this.state.isCurrent ? "block" : "none"
    };
  }

  trackPageEvent(label) {
    SMTrackHelper.pageEvent(label);
  }

  formDidSubmit(resource, e) {
    e.preventDefault();
    if (e.currentTarget.name == 'owner_review') {
      this.requestOwnerReview(resource);
    } else if (e.currentTarget.name == 'room_review') {
      this.requestRoomReview(resource);
    }
  }

  linkDidClick(resource, e) {
    e.preventDefault();
    this.requestRoomReview(resource);
  }
  
  requestOwnerReview(owner) {
    this.trackPageEvent('od request owner_review');
    $(this.refs.fragment).startLoading();
    SMOwnerResource.requestReview(owner.id, (owner, error, xhr)=>{
      if (xhr.status == 200) {
        if (this.state.owner.status == SMConst.OwnerStatus.Created && this.props.requestHost == "spacemarket.com") {
          this.setState({requestStatus: 200});
        } else {
          location.reload();
        }
      } else {
        $(this.refs.fragment).stopLoading();
        if (xhr.status == 400) {
          $("#js-split_view-main").showFailMessage(
            "審査に提出した内容に問題があります。修正後に再度審査依頼ボタンを押して下さい。: " + 
            xhr.responseJSON.message, { duration: 10000 }
          );
        }
      }
    });
  }
  
  requestRoomReview(room) {
    this.trackPageEvent('od request room_review');
    $(this.refs.fragment).startLoading();
    SMOwnerResource.requestRoomReview(this.state.owner.id, room.id, (room, error, xhr)=>{
      if (xhr.status == 200) {
        location.reload();
      } else {
        $(this.refs.fragment).stopLoading();
        console.error(xhr.responseJSON.message);
      }
    });
  }
  
  renderOwnerReviewButton() {
    let necessaryInformation = [];
    let necessaryInformationLink = Routes.owner_dashboard_settings_account_path(this.state.owner.username);
    let errorReason = '';
    if (!this.state.owner.personal_certificate.name) {
      necessaryInformation.push(I18n.t('dashboard.label_000251'));
    }
    if (!this.state.owner.gender) {
      necessaryInformation.push(I18n.t('dashboard.label_000907'));
    }
    if (!this.state.owner.birth_date) {
      necessaryInformation.push(I18n.t('dashboard.label_000052'));
    }
    if (!this.hasName()) {
      necessaryInformation.push(I18n.t('dashboard.label_000050'));
    }
    if (!this.hasAddress()) {
      necessaryInformation.push("住所とカナ");
      necessaryInformationLink = Routes.owner_dashboard_settings_address_path(this.state.owner.username);
    }
    
    if (this.state.owner.is_corp) {
      if (!this.state.owner.corp_name_en) {
        necessaryInformation.push(I18n.t('dashboard.label_000913'));
      }
      if (!this.state.owner.business_tax_id) {
        necessaryInformation.push(I18n.t('dashboard.label_000906'));
      }
      if (!this.hasPersonalAddress()) {
        necessaryInformation.push("担当者の住所とカナ");
        necessaryInformationLink = Routes.owner_dashboard_settings_address_path(this.state.owner.username);
      }
    }
    if (necessaryInformation.length > 1) {
      necessaryInformation = necessaryInformation.join('， ');
    }

    let label = '',
        buttonColor = 'button-disabled',
        isDisabled,
        description,
        goToAccountSettingButton = <a key='goToAccountSettingButton' href={necessaryInformationLink} className="link-hover-border">{necessaryInformation}</a>,
        goToSpaceListButton = <a key='goToSpaceListButton' href={Routes.owner_dashboard_spaces_path(this.state.owner.username)} className="link-hover-border">{I18n.t('dashboard.label_000252')}</a>,
        goToBankAccountSettingButton = <a key='goToBankAccountSettingButton' href={Routes.owner_dashboard_settings_bank_account_path(this.state.owner.username)} className="link-hover-border">{I18n.t('dashboard.label_000912')}</a>;

        
    if (this.state.display == SMConst.Display.Visible) {
      if (!this.canRequestOwnerCertificate()) {
        label = I18n.t('dashboard.label_000250');
        buttonColor = "button-disabled";
        isDisabled = true;
        description = [I18n.t('dashboard.label_000253')];
        
        if (!this.hasBankAccount()){
          description.push(goToBankAccountSettingButton, I18n.t('dashboard.label_000255'));
        }
        if (!this.hasValidOwnerInfo()){
          description.push(goToAccountSettingButton, I18n.t('dashboard.label_000255'));
        }
        if (!this.hasDisplayableRoom()) {
          description.push(goToSpaceListButton, I18n.t('dashboard.label_000255'));
        }
      } else {
        if (this.state.owner.status == SMConst.OwnerStatus.Created) {
          label = I18n.t('dashboard.label_000250');
          buttonColor = "button-blue";
          isDisabled = false;
          description = I18n.t('dashboard.text_000060');
        } else if (this.state.owner.status == SMConst.OwnerStatus.Rejected) {
          label = I18n.t('dashboard.label_000260');
          buttonColor = "button-disabled";
          isDisabled = true;
          description = I18n.t('dashboard.text_000065');
        } else if (this.state.owner.status == SMConst.OwnerStatus.Requested) {
          if (this.state.owner.card_account_status == 'unverified' &&
              this.state.owner.card_account_unverified_code_text != null &&
              this.state.owner.card_account_disabled == false) {
            label = I18n.t('dashboard.label_000250');
            buttonColor = "button-blue";
            isDisabled = false;
            description = I18n.t('dashboard.text_000070');
            errorReason = <p className="is-error"><i className="fa fa-exclamation-circle mr5"></i>{this.state.owner.card_account_unverified_code_text}</p>;
          } else if (this.state.owner.card_account_status != null) {
            label = I18n.t('dashboard.label_000256');
            buttonColor = "button-disabled";
            isDisabled = true;
            description = I18n.t('dashboard.text_000061');
          } else {
            // webpayで審査中だがstripeに審査を出していない場合、審査ボタン押せるようにする
            label = I18n.t('dashboard.label_000250');
            buttonColor = "button-blue";
            isDisabled = false;
            description = I18n.t('dashboard.text_000060');
          }
        } else if (this.state.owner.status == SMConst.OwnerStatus.Confirmed) {
          if (this.state.owner.card_account_status == 'pending' ||
              this.state.owner.card_account_disabled == true) {
            label = I18n.t('dashboard.label_000256');
            buttonColor = "button-disabled";
            isDisabled = true;
            description = I18n.t('dashboard.text_000813');
          } else if (this.state.owner.card_account_status == 'verified') {
            label = I18n.t('dashboard.label_000257');
            buttonColor = "button-disabled";
            isDisabled = true;
            description = I18n.t('dashboard.text_000062');
          } else if (this.state.owner.card_account_status == 'unverified' &&
                     this.state.owner.card_account_unverified_code_text != null &&
                     this.state.owner.card_account_disabled == false) {
            label = I18n.t('dashboard.label_000250');
            buttonColor = "button-blue";
            isDisabled = false;
            description = I18n.t('dashboard.text_000070');
            errorReason = <p className="is-error"><i className="fa fa-exclamation-circle mr5"></i>{this.state.owner.card_account_unverified_code_text}</p>;
          } else {
            // webpayで審査完了だがstripeに審査を出していない場合、審査ボタン押せる
            label = I18n.t('dashboard.label_000250');
            buttonColor = "button-blue";
            isDisabled = false;
            description = I18n.t('dashboard.text_000060');
          }
        } else if (this.state.owner.status == SMConst.OwnerStatus.Banned) {
          label = I18n.t('dashboard.label_000257');
          buttonColor = "button-disabled";
          isDisabled = true;
          description = I18n.t('dashboard.text_000062');
        }
      }
    }
    
    return(
      <div className="settings-exam__box">
        <div className="settings-exam__textarea">
          <p>{description}</p>
          {errorReason}
        </div>
        <div className="settings-exam__buttonarea">
          <input type="submit" disabled={isDisabled} className={"button settings-exam__button "+buttonColor} value={label} />
        </div>
      </div>
    );
  }
  
  createRoomReviewButton(room, index) {
    let label = '',
        buttonColor = 'button-disabled',
        isDisabled = true,
        description;
      
    if (room.stay_certification_status == SMConst.StayCertificationStatus.NotSubmitted) {
      label = I18n.t('dashboard.label_000250');
      if (room.can_display && room.space.can_display && room.has_stay_certification) {
        buttonColor = "button-blue";
        isDisabled = false;
        description = <p>{I18n.t('dashboard.text_000064')}<a href={Routes.edit_owner_dashboard_space_room_path(room.owner_id, room.space.username, room.uid)}>{I18n.t('dashboard.label_000259')}</a></p>;
      } else {
        description = <p>{I18n.t('dashboard.text_000063')}<a href={Routes.edit_owner_dashboard_space_room_path(room.owner_id, room.space.username, room.uid)}>{I18n.t('dashboard.label_000258')}</a></p>;
      }
    } else if (room.stay_certification_status == SMConst.StayCertificationStatus.Created || 
               room.stay_certification_status == SMConst.StayCertificationStatus.Investigating) {
        label = I18n.t('dashboard.label_000256');
        description = <p>{I18n.t('dashboard.text_000061')}</p>;
    } else if (room.stay_certification_status == SMConst.StayCertificationStatus.Declined) {
        label = I18n.t('dashboard.label_000260');
        description = <p>{I18n.t('dashboard.text_000065')}<a href="#" onClick={this.linkDidClick.bind(this, room)} className="link-hover-border">{I18n.t('dashboard.label_000261')}</a></p>;
    }

    return(
      <div key={room.id} className="settings-exam__box">
        <div className="settings-exam__textarea">
          <p className="dashboard-title2"><a href={Routes.space_room_path(room.space.username, room.uid)} className="link-hover-border">{SMFormatHelper.roomName(room)}</a></p>
          {description}
        </div>
        <div className="settings-exam__buttonarea">
          <form name='room_review' onSubmit={this.formDidSubmit.bind(this, room)}>
            <input type="submit" disabled={isDisabled} className={"button settings-exam__button "+buttonColor} value={label} />
          </form>
        </div>
      </div>
    );
  }
  
  didLoadImage() {
    location.reload();
  }
  
  a8BeaconTag() {
    let params = {order_id: this.state.owner.id, unit_amount: 3000, number: 1, total_amount: 3000, item_code: "host"};
    return <SMA8Beacon delegate={this} params={params} />;
  }
  
  render() {
    return (
      <div ref="fragment" style={this.fragmentStyle()}>
        <h2 className="dashboard-title mb20">
          <span className="icon-form icon-form__required">{I18n.t('dashboard.label_000025')}</span>{I18n.t('dashboard.label_000145')}<br />
          <span className="dashboard-title__supplement" dangerouslySetInnerHTML={{__html: I18n.t('dashboard.text_000067_html') }} />
        </h2>
        <form name='owner_review' onSubmit={this.formDidSubmit.bind(this, this.props.owner)}>
          <div className="form-box">
            {this.renderOwnerReviewButton()}
            {(this.state.requestStatus == 200) ? this.a8BeaconTag() : null}
          </div>
        </form>
        
        <h2 className="dashboard-title mb20">
          <span className="icon-form icon-form__required">{I18n.t('dashboard.label_000025')}</span>{I18n.t('dashboard.label_000264')}<br />
          <span className="dashboard-title__supplement" dangerouslySetInnerHTML={{__html: I18n.t('dashboard.text_000068_html') }} />
        </h2>
        <h3 className="dashboard-title2 mb15">{I18n.t('dashboard.label_000264')}</h3>
        <div className="form-box">
          {(this.state.reviewRequiredRooms.length == 0) ? <p key='empty'>{I18n.t('dashboard.text_000066')}</p> 
                                          : this.state.reviewRequiredRooms.map(this.createRoomReviewButton, this)}
        </div>
      </div>
    );
  }
}

SMOSettingEditReviewFragmentView.propTypes = {
  owner: PropTypes.object.isRequired,
};
export default SMOSettingEditReviewFragmentView;



// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/owners/settings/SMOSettingEditReviewFragmentView.jsx